<template lang="pug">
tooltip(:tip="title", top)
  img.brand-card-img(:src="img")
</template>

<script>
import Tooltip from "../tools/Tooltip.vue";

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
  },
  components: {
    Tooltip,
  },
};
</script>

<style>
.brand-card-img {
  max-width: 120px !important;
  width: 100% !important;
  height: 48px;
  object-fit: contain;
  filter: brightness(0) invert(1);
  transition: 0.8s;
}
.brand-card-img:hover {
  filter: initial;
}
</style>
